export const convertToMilliseconds = (value: number) => {
    return value * 1000;
};
